import React, { useState, Fragment } from "react";

interface InputProps {
  pattern: string;
  type: string;
  id: string;
  name: string;
  placeholder: string;
  value: string;
  className: string;
  disabled: boolean;
  price: boolean;
  usd: boolean;
  handleChange: (e: any) => void;
}
const Input = ({
  type,
  pattern,
  id,
  name,
  placeholder,
  value,
  className,
  disabled,
  price,
  usd,
  handleChange
}:InputProps) => {
  let activeInput;
  if (disabled) {
    activeInput = (
      <>
        <input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          className={`block w-72 h-12 rounded-xl  sm:text-sm border-none bg-slate-100 ${className}`}
          onChange={handleChange}
          disabled
          readOnly
        />
      </>
    );
  } else {
    if (price && usd) {
      activeInput = (
        <>
          <input
            type={type}
            name={name}
            id={id}
            defaultValue={value}
            placeholder={placeholder}
            className={`${className} rounded-xl border-none bg-light-green sm:text-sm`}
            onChange={handleChange}
            disabled
            readOnly
          />
        </>
      );
    } else if (price) {
      activeInput = (
        <>
          <input
            type={type}
            name={name}
            id={id}
            placeholder={placeholder}
            className={`${className} rounded-xl border-none focus:ring-logo-green bg-white sm:text-sm`}
            onChange={handleChange}
          />
        </>
      );
     
    } else {
      activeInput = (
        <>
          <input
            type={type}
            name={name}
            pattern={pattern}
            id={id}
            placeholder={placeholder}
            className={`block w-72 h-12 rounded-xl  sm:text-sm border-2 border-solid border-slate-200 bg-white  focus:border-logo-green focus:border-2 focus:border-solid ${className}`}
            onChange={handleChange}
          />
        </>
      );
    }
  }

  return <>{activeInput}</>;
};
export default Input;
